import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

import { cn } from 'src/common/utils';
import { Card } from 'src/common/components/Card';
import { LanguageSelector } from 'src/common/components/LanguageSelector/LanguageSelector';
import Background from 'src/assets/login_background.jpg';
import Logo from 'src/assets/UG_Logo_RGB_Lime_White_Blue-Background.png';
import { resolveLanguageForUrl } from '../util';

type Props = {
  children: ReactNode;
  aside?: ReactNode;
};

export const AuthLayout = ({ children, aside }: Props) => {
  const { t, i18n } = useTranslation('auth');
  const language = resolveLanguageForUrl(i18n.language);

  return (
    <div
      className="relative flex h-full w-full items-center justify-center overflow-y-auto bg-cover bg-fixed bg-center px-6 pb-16 max-md:items-start max-md:px-4 max-md:py-2"
      style={{ backgroundImage: `url(${Background})` }}
    >
      <div className="m-auto flex flex-col max-md:m-0 max-md:w-full">
        <div className="mb-2 flex items-end justify-between gap-4 max-md:mb-1">
          <img
            src={Logo}
            alt="SDA Logo"
            className="w-[200px] max-md:w-[140px]"
          />
          <LanguageSelector aria-label={t('authLayout.language')} />
        </div>
        <Card
          className={cn(
            'relative m-auto',
            aside ? 'max-w-[928px]' : 'max-w-md',
          )}
        >
          <div className={cn({ 'grid md:grid-cols-2': aside })}>
            {aside ? (
              <aside className="bg-gray-100 px-8 py-6 max-md:px-4 max-md:py-2">
                {aside}
              </aside>
            ) : null}
            <div className="pb-8 pt-9 max-md:pb-2 max-md:pt-3">{children}</div>
          </div>
        </Card>
      </div>
      <div className="fixed bottom-0 left-0 flex w-full gap-4 bg-white px-4 py-3 max-md:gap-2 max-md:py-2">
        <a
          href={import.meta.env.VITE_HELP_URL}
          target="_blank"
          rel="noreferrer"
          className="text-sm text-shuttleGray-600"
        >
          {t('authLayout.helpCenter')}
        </a>
        <span className="text-sm text-shuttleGray-600">
          {t('authLayout.version')} {import.meta.env.VITE_VERSION}
        </span>
        <a
          href="https://umdaschgroup-ventures.com/privacy-policy/"
          target="_blank"
          rel="noreferrer"
          className="ml-auto text-sm text-shuttleGray-600"
        >
          {t('authLayout.copyright')}
        </a>
        <a
          href={
            language === 'de'
              ? 'https://umdaschgroup-ventures.com/de/datenschutzerklaerung/'
              : 'https://umdaschgroup-ventures.com/privacy-policy/'
          }
          target="_blank"
          rel="noreferrer"
          className="text-sm text-shuttleGray-600"
        >
          {t('authLayout.privacy')}
        </a>
      </div>
    </div>
  );
};
